import { Drawer, Grid, SwipeableDrawer, useMediaQuery } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styles from "../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import { manualAgentData } from '../../../models/axiosModel';
import GlobalDeletePopup from '../../../components/utility/globalDeletePopup/globalDeletePopup';
import { useRuleBasedInboxStore } from '../../../store/ruleBasedInboxStore';
import { useShallow } from 'zustand/react/shallow';
import InfoPanel from './components/infoPanel';

interface ChatInformationBlockInterface {
    flagMobile?: true,
    handleToggleManualOverride: (user_assignment_id: string, flag_delete_agent: boolean) => void,
    flagSendAgentActivityMsg: boolean,
}
function ChatInformationBlock(props: ChatInformationBlockInterface) {
    const smallScreen = useMediaQuery('(max-width : 1250px) and (min-width : 1000px)')
    const laptopScreen = useMediaQuery('(max-width : 1600px) and (min-width : 1000px)')

    const {
        setSelectedAgentId, flagOpenThreadInfoBlock, setFlagOpenThreadInfoBlock, toggleThreadInfoPanel,
        setFlagSendAgentActivityMsgConfirmation
    } = useRuleBasedInboxStore(useShallow((state) => ({
        setSelectedAgentId: state.setSelectedAgentId,
        flagOpenThreadInfoBlock: state.flagOpenThreadInfoBlock,
        setFlagOpenThreadInfoBlock: state.setFlagOpenThreadInfoBlock,
        toggleThreadInfoPanel: state.toggleThreadInfoPanel,
        setFlagSendAgentActivityMsgConfirmation: state.setFlagSendAgentActivityMsgConfirmation,
    })))

    // Destructure function props
    const { flagMobile, handleToggleManualOverride, flagSendAgentActivityMsg } = props

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [selectedAgent, setSelectedAgent] = useState<manualAgentData | null>(null);

    const handleRemoveAgent = useCallback((e: any, agent: manualAgentData) => {
        e.stopPropagation();
        if(flagSendAgentActivityMsg){
            setSelectedAgentId(agent?.user_assignment_id);
            setFlagSendAgentActivityMsgConfirmation(true);
        } else {
            setSelectedAgent(agent);
            setShowDeleteConfirmation(true);
        }
    }, [flagSendAgentActivityMsg, setSelectedAgentId, setFlagSendAgentActivityMsgConfirmation])

    useEffect(() => {
        if (!laptopScreen && flagOpenThreadInfoBlock) {
            window.history.pushState({ drawer: true }, "");
        
            const handlePopState = () => {
                toggleThreadInfoPanel();
            };
        
            window.addEventListener("popstate", handlePopState);
        
            return () => {
                window.removeEventListener("popstate", handlePopState);
            };
        }
    }, [laptopScreen, flagOpenThreadInfoBlock]);

    return (
        <>
            <Grid item
                xs={flagMobile ? smallScreen ? 6 : 12 : undefined}
                className={`${flagMobile
                    ? styles.chatInformationBlockMobile
                    : flagOpenThreadInfoBlock
                        ? styles.chatInformationBlockDesktopOpen
                        : styles.chatInformationBlockDesktopClosed
                    } ${flagMobile && smallScreen
                        ? `${styles.chatInformationBlockMobileSmallScreenPadding} ${styles.chatInformationBlockMobileSmallScreenHeight}`
                        : styles.chatInformationBlockAutoHeight
                    }`}
            >

                <Grid container className={styles.chatInformationBlockContainer} onClick={toggleThreadInfoPanel}>
                    {flagOpenThreadInfoBlock ?
                        <ChevronRightIcon className={`${styles.chatInformationBlockChevronIcon} ${flagMobile ? styles.chatInformationBlockChevronIconFlagMobile : styles.chatInformationBlockChevronIconNormal}`} />
                        :
                        <ChevronLeftIcon className={`${styles.chatInformationBlockChevronIcon} ${flagMobile ? styles.chatInformationBlockChevronIconFlagMobile : styles.chatInformationBlockChevronIconNormal}`} />
                    }
                </Grid>
                {!laptopScreen ? <Drawer
                    className={`${styles.chatInformationBlockDrawer} ${!flagOpenThreadInfoBlock ? styles.chatInformationBlockDrawerDisplayNone : ""}`}
                    classes={{
                        paper: styles.chatInformationBlockDrawerPaper
                    }}
                    variant='persistent'
                    open={flagOpenThreadInfoBlock}
                    anchor="right"
                >
                    <InfoPanel onRemoveAgent={handleRemoveAgent} />
                </Drawer>
                    :
                    <SwipeableDrawer
                        anchor="right"
                        open={flagOpenThreadInfoBlock}
                        onClose={() => setFlagOpenThreadInfoBlock(!flagOpenThreadInfoBlock)}
                        onOpen={() => setFlagOpenThreadInfoBlock(!flagOpenThreadInfoBlock)}
                        hideBackdrop={false}
                        className={styles.chatSwipableDrawerStyle}
                        PaperProps={{
                            className: styles.userInfoSwipeableDrawer,
                        }}
                    >
                        <Grid item className={globalStyles.relativePosition}>
                            <ChevronRightIcon
                                className={`${styles.chatInformationBlockChevronIconNew} ${styles.chatInformationBlockChevronIcon}`}
                                onClick={toggleThreadInfoPanel}
                            />
                            <InfoPanel onRemoveAgent={handleRemoveAgent} />
                        </Grid>
                    </SwipeableDrawer>
                }
            </Grid>
            { showDeleteConfirmation &&
                <GlobalDeletePopup
                    open={showDeleteConfirmation}
                    title="Remove Confirmation"
                    deleteDescription={`Are you sure you want to remove ${selectedAgent?.private_user_first_name + " " + (selectedAgent?.private_user_last_name ?? "")} as an agent`}
                    primaryButtonText="Remove"
                    onClose={() => { setShowDeleteConfirmation(false) }}
                    onDelete={() => {
                        if (selectedAgent) {
                            handleToggleManualOverride(selectedAgent.user_assignment_id, true);
                        }
                        setShowDeleteConfirmation(false);
                    }}
                />
            }
        </>
    )
}

export default ChatInformationBlock
